import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import { post } from "../axios-post";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TFlaggedDescriptionsArray } from "../../Types";

export const apiGetFlaggedDescription = async (): Promise<{
  data: TFlaggedDescriptionsArray;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TFlaggedDescriptionsArray>(
    `supervisor/getSupervisorFlaggedDescription`,
    {}
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
